/**
 * @flow
 * @relayHash df4219c37c92567541790ae92aea742d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ReleaseDetails_release$ref = any;
export type ReleaseDetailsPageQueryVariables = {|
  id: string
|};
export type ReleaseDetailsPageQueryResponse = {|
  +release: ?{|
    +$fragmentRefs: ReleaseDetails_release$ref
  |}
|};
export type ReleaseDetailsPageQuery = {|
  variables: ReleaseDetailsPageQueryVariables,
  response: ReleaseDetailsPageQueryResponse,
|};
*/


/*
query ReleaseDetailsPageQuery(
  $id: ID!
) {
  release(id: $id) {
    ...ReleaseDetails_release
    id
  }
}

fragment ReleaseDetails_release on ReleaseNode {
  id
  name
  product {
    id
    code
    title
    representativeImageUrl
  }
  deadline
  isActive
  hasIncompleteDeliverables
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReleaseDetailsPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "release",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ReleaseNode",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReleaseDetails_release",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ReleaseDetailsPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "release",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ReleaseNode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "product",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "representativeImageUrl",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "deadline",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActive",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasIncompleteDeliverables",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ReleaseDetailsPageQuery",
    "id": null,
    "text": "query ReleaseDetailsPageQuery(\n  $id: ID!\n) {\n  release(id: $id) {\n    ...ReleaseDetails_release\n    id\n  }\n}\n\nfragment ReleaseDetails_release on ReleaseNode {\n  id\n  name\n  product {\n    id\n    code\n    title\n    representativeImageUrl\n  }\n  deadline\n  isActive\n  hasIncompleteDeliverables\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fea1c6d20f442afbf86c04fb3fcc4d00';
module.exports = node;
